import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';

import { ManageOrdersList } from '../ManageOrderList';

export const RequisitesVerificationOrders: React.FC = () => {
  useOrderQueryFilters();

  return (
    <ManageOrdersList
      tab={OrdersTab.RequisitesVerification}
      additionalColumns={[
        AdditionalOrderColumn.Trader,
        AdditionalOrderColumn.TraderCard,
      ]}
    />
  );
};
